import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=6bd1dd8c&scoped=true"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=6bd1dd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1dd8c",
  null
  
)

export default component.exports